const types = {
    WEEK: 'WEEK',
    MONTH: 'MONTH',
    YEAR: 'YEAR',
    DAY: 'DAY'
  };
  export default types;
  